import html from "../../../images/html5.png";
import css from "../../../images/css.jpg";
import bootstrap from "../../../images/boot.png";
import tailwind from "../../../images/tailwind.avif";
import pyhton from "../../../images/pyhton.png";
import laravel from "../../../images/laravel.png";
import nest from "../../../images/nest.png";
import gitlab from "../../../images/gitlab.png";
import github from "../../../images/github.png";

export const frontendTrack = [
  {
    id: 1,
    title: "HTML",
    image: html,
    description: "HTML is the standard markup language for Web pages. With HTML you can create your own Website. HTML is easy to learn - You will enjoy it! Study our free HTML.",
    link: "/trackDetail",
  },
  {
    id: 2,
    title: "CSS",
    image: css,
    description: "CSS stands for Cascading Style Sheets · CSS describes how HTML elements are to be displayed on screen, paper, or in other media.",
    link: "/trackDetail",
  },
  {
    id: 3,
    title: "Bootstrap",
    image: bootstrap,
    description: "Powerful, extensible, and feature-packed frontend toolkit. Build and customize with Sass, utilize prebuilt grid system and components, and bring projects. .",
    link: "/trackDetail",
  },
  {
    id: 4,
    title: "Tailwind",
    image: tailwind,
    description: "Tailwind CSS is a utility-first CSS framework for rapidly building modern websites without ever leaving your HTML.",
    link: "/trackDetail",
  },
 
];



export const backendTrack = [
    {
      id: 5,
      title: "PHP-Laravel",
      image: laravel,
      description: "Easy Learning with HTML 'Try it Yourself' · HTML Examples · HTML Exercises · Test Yourself With Exercises · Exercise: · HTML Quiz Test · My Learning · HTML References.",
      link: "/trackDetail",
    },
    {
      id: 6,
      title: "Pyhton-Django",
      image: pyhton,
      description: "Easy Learning with HTML 'Try it Yourself' · HTML Examples · HTML Exercises · Test Yourself With Exercises · Exercise: · HTML Quiz Test · My Learning · HTML References.",
      link: "/trackDetail",
    },
    {
      id: 7,
      title: "Nest-js",
      image: nest,
      description: "Easy Learning with HTML 'Try it Yourself' · HTML Examples · HTML Exercises · Test Yourself With Exercises · Exercise: · HTML Quiz Test · My Learning · HTML References.",
      link: "/trackDetail",
    }
  ];

  
export const versionTrack = [
    {
      id: 8,
      title: "GitLab",
      image: gitlab,
      description: "Easy Learning with HTML 'Try it Yourself' · HTML Examples · HTML Exercises · Test Yourself With Exercises · Exercise: · HTML Quiz Test · My Learning · HTML References.",
      link: "/trackDetail",
    },
    {
        id: 9,
        title: "GitHub",
        image: github,
        description: "Easy Learning with HTML 'Try it Yourself' · HTML Examples · HTML Exercises · Test Yourself With Exercises · Exercise: · HTML Quiz Test · My Learning · HTML References.",
        link: "/trackDetail",
      }

  ];